module.exports = __webpack_public_path__ + "img/SMT_46_Lim_Kwang_Kok.78b65dc6.jpg";